export default __webpack_public_path__ + "static/media/arisan-video.7015aa91.mp4";